/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecurityWeight
 */
export interface SecurityWeight {
    /**
     * 
     * @type {string}
     * @memberof SecurityWeight
     */
    sId: string;
    /**
     * 
     * @type {number}
     * @memberof SecurityWeight
     */
    weight: number;
}

/**
 * Check if a given object implements the SecurityWeight interface.
 */
export function instanceOfSecurityWeight(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "weight" in value;

    return isInstance;
}

export function SecurityWeightFromJSON(json: any): SecurityWeight {
    return SecurityWeightFromJSONTyped(json, false);
}

export function SecurityWeightFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityWeight {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': json['s_id'],
        'weight': json['weight'],
    };
}

export function SecurityWeightToJSON(value?: SecurityWeight | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's_id': value.sId,
        'weight': value.weight,
    };
}

